import styled from "styled-components";

export const PlayerWrapper = styled.div<{ isVertical: boolean }>`
  position: relative;
  width: 100%;
  max-width: ${({ isVertical }) => (isVertical ? "320px" : "100%")};
  max-height: ${({ isVertical }) => (isVertical ? "90vh" : "70vh")};

  video {
    border-radius: 12px;
    width: 100%;
    height: auto;
    object-fit: contain;
    background: #000;
  }

  .plyr--full-ui input[type="range"] {
    color: ${({ theme }) => theme.colors.Primary};
  }

  .plyr__control--overlaid,
  .plyr__control {
    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.colors.Primary} !important;
    }
  }

  .plyr__control--pressed,
  .plyr__control[aria-pressed="true"] {
    background-color: ${({ theme }) => theme.colors.Primary} !important;
  }

  .plyr__progress--buffer,
  .plyr__progress input[type="range"]::-webkit-slider-thumb,
  .plyr__progress input[type="range"]::-moz-range-thumb,
  .plyr__progress input[type="range"]::-ms-thumb {
    background-color: ${({ theme }) => theme.colors.Primary} !important;
  }

  .plyr__menu__container {
    border-color: ${({ theme }) => theme.colors.Primary};
  }

  .plyr__menu__container .plyr__control--highlight {
    color: ${({ theme }) => theme.colors.Primary};
  }
`;

export const OptimizationBanner = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(2px);
  z-index: 10;
`;

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover > div {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const TooltipText = styled.div`
  position: absolute;
  top: 120%;
  left: -100px;
  background-color: #000;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 11.5px;
  white-space: normal;
  line-height: 1.4;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 20;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  pointer-events: none;
  width: 200px;
`;
